export const sendMtagData = () => {
  window.mtagq = window.mtagq || [];
  window.mtagq.push(
    'event',
    'Smart Page Leads Tracking',
    {}
  );
};
